import { Test } from "oc-e2e-testrunner";
import { assertEqualsBestellliste, resetArrangement } from "./utils";

export default {
  name: "TestStückliste-Neo_Thermo-Holz",
};
export const testNeoSenkrecht_176x185: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM NEO HOLZ Thermoholz",
    massAuswahlwert: "[Senkrecht] 180x180_Easy",
    höhe: 1.852,
    abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "3800",
        Anzahl: 1,
      },
      {
        ArtikelID: "2775",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 2,
      },
      {
        ArtikelID: "2314",
        Anzahl: 2,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};

export const testNeoSenkrecht_176x98: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM NEO HOLZ Thermoholz",
    massAuswahlwert: "[Senkrecht] 180x180_Easy",
    höhe: 0.98,
    abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "3801",
        Anzahl: 1,
      },
      {
        ArtikelID: "2775",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 2,
      },
      {
        ArtikelID: "2314",
        Anzahl: 2,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};

export const testNeoRegular_178x185: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM NEO HOLZ Thermoholz",
    massAuswahlwert: "180x180_Easy",
    abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "3800",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 2,
      },
      {
        ArtikelID: "2314",
        Anzahl: 2,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
      {
        ArtikelID: "287",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};
export const testNeoRegular_91x185: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [1.2]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM NEO HOLZ Thermoholz",
    massAuswahlwert: "180x180_Easy",
    breite: 0.91,
    abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "3801",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 2,
      },
      {
        ArtikelID: "2314",
        Anzahl: 2,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
      {
        ArtikelID: "287",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};
